import UnderConstruction from "../common/UnderConstruction";

export default function InventoryReturn() {
  return <UnderConstruction title="Return Register" />;
}
